export enum LocalStorageKeys {
  // Availaibility
  AvailabilityPostcode = 'Availability-Postcode',
  AvailabilitySuburb = 'Availability-Suburb',

  // Cart
  GiftCardAppliedAmount = 'gift_card_applied_amount',
  MySelectedStore = 'my-selected-store',

  // Search
  RecentSearches = 'recentSearches',
  RecentlyViewed = 'recentlyViewed',

  // Coupons
  ShouldShowSpendAndGetBanner = 'shouldShowSpendAndGetBanner',
}

//
// Functions for local storage actions
//

/**
 * Set to localStorage
 */
export const setLocal = (key: LocalStorageKeys, data: any, isJson = false) => {
  if (!window.localStorage) {
    return;
  }

  try {
    localStorage.setItem(key, isJson ? JSON.stringify(data) : data);
  } catch (e) {
    console.error('Saving to localStorage failed', e);
  }
};

/**
 * Get from localStorage
 */
export const getLocal = (key: LocalStorageKeys, isJson = false) => {
  if (!window.localStorage) {
    return '';
  }

  let data: any;
  try {
    data = localStorage.getItem(key);
    if (isJson) {
      data = JSON.parse(data);
    }
  } catch (e) {
    console.error('Getting from localStorage failed', e);
  }

  return data;
};

/**
 * Remove localStorage
 */
export const removeLocal = (key: LocalStorageKeys) => {
  if (!window.localStorage) {
    return;
  }

  localStorage.removeItem(key);
};

/**
 * Add to localStorage set
 */
export const addToLocalSet = (key: LocalStorageKeys, data: any) => {
  if (!window.localStorage) {
    return;
  }

  const existing = getLocal(key, true) || [];
  if (Array.isArray(existing)) {
    const set = new Set(existing);
    set.add(data);
    setLocal(key, Array.from(set), true);
  } else {
    setLocal(key, [data], true);
  }
};
